import React, { useEffect } from 'react';

interface IDriftChatProps {
  onClick?: () => void;
}

const DriftChat = ({ onClick }: IDriftChatProps): React.ReactElement => {
  useEffect(() => {
    if ((window as any).drift) {
      (window as any).drift.on('ready', function () {
        (window as any).drift.api.widget.hide();
      });
    } else {
      (window as any).loadDrift();
    }
  }, []);

  const handleDriftOpen = () => {
    (window as any).drift.api.startInteraction({ interactionId: 41771 });
    onClick?.();
  };

  return (
    <>
      <div
        onClick={handleDriftOpen}
        dangerouslySetInnerHTML={{
          __html: `    <div class="dropdown text-end drift-open-chat">
      <main role="main" aria-label="Drift Widget messenger icon">
        <style>
          .drift-widget-controller.keyboard-focused:before {
            border: 2px solid #0176ff;
            border-radius: 4px;
            content: ' ';
            position: absolute;
            left: 6px;
            top: -6px;
            width: 50px;
            height: 50px;
          }

          .drift-open-chat {
            padding-right: 10px;
          }

          .drift-widget-controller {
            border-radius: 100%;
            padding: 6px;
            border: none;
          }
        </style>
        <button
          class="drift-widget-controller drift-widget-controller--align-right square"
          aria-label="Click to open chat with LiveXbot in the Drift Widget messenger"
          style="background: rgb(23, 65, 120)"
        >
          <div class="drift-widget-controller-icon square">
            <div class="drift-controller-icon--active">
              <svg class="drift-default-icon drift-default-icon--chat-round" width="35" height="35" viewBox="0 0 25 23">
                <path
                  d="M24.516 9.953C24.516 4.453 19.04 0 12.258 0 5.476 0 0 4.452 0 9.953c0 3.318 1.986 6.24 5.05 8.053-.34 2.552-1.815 4.055-1.844 4.084-.14.14-.17.368-.113.567a.524.524 0 0 0 .482.312c2.95 0 5.335-1.93 6.612-3.206.652.086 1.362.142 2.07.142 6.783 0 12.26-4.452 12.26-9.953z"
                  fill="#FFFFFF"
                ></path>
              </svg>
            </div>
            <div class="drift-controller-icon--close" style="background-color: rgb(255, 255, 255)"></div>
          </div>
        </button>
        <div>
          <div
            role="log"
            aria-live="assertive"
            style="
              border: 0px;
              clip: rect(0px, 0px, 0px, 0px);
              height: 1px;
              margin: -1px;
              overflow: hidden;
              white-space: nowrap;
              padding: 0px;
              width: 1px;
              position: absolute;
            "
          ></div>
          <div
            role="log"
            aria-live="assertive"
            style="
              border: 0px;
              clip: rect(0px, 0px, 0px, 0px);
              height: 1px;
              margin: -1px;
              overflow: hidden;
              white-space: nowrap;
              padding: 0px;
              width: 1px;
              position: absolute;
            "
          ></div>
          <div
            role="log"
            aria-live="polite"
            style="
              border: 0px;
              clip: rect(0px, 0px, 0px, 0px);
              height: 1px;
              margin: -1px;
              overflow: hidden;
              white-space: nowrap;
              padding: 0px;
              width: 1px;
              position: absolute;
            "
          ></div>
          <div
            role="log"
            aria-live="polite"
            style="
              border: 0px;
              clip: rect(0px, 0px, 0px, 0px);
              height: 1px;
              margin: -1px;
              overflow: hidden;
              white-space: nowrap;
              padding: 0px;
              width: 1px;
              position: absolute;
            "
          ></div>
        </div>
      </main>
    </div>`,
        }}
      ></div>
    </>
  );
};

export default DriftChat;
